import { IressSlideout, IressTable, IressText } from '@iress-oss/ids-components';
import { FC, useMemo, useRef, useState } from 'react';
import '../../../styles/IdsTableDisplay.css';
import { Scenario } from '@xplan-pension-switching/common';
import { scenarioTableColumns } from './ScenarioTableColumns/ScenarioTableColumns';
import { useScenarioTableData } from '../../../hooks';

export const ScenariosTable: FC<{ scenarios: Scenario[] }> = props => {
    const { scenarios } = props;
    const hasExistingScenario = useMemo(() => scenarios && scenarios.length > 0, [scenarios]);
    const noExistingScenarioLabel = 'No existing scenarios';
    const { rows, selectedScenario } = useScenarioTableData(scenarios);
    const slideoutRef = useRef<HTMLDivElement>(null);
    const [show, setShow] = useState(false);

    return (
        <>
            <div data-testid="scenario-table-container">
                {hasExistingScenario ? (
                    <IressTable
                        caption="Existing scenarios"
                        className="xps-table"
                        scope="col"
                        hiddenCaption
                        columns={scenarioTableColumns}
                        rows={rows}
                        data-testid="scenario-table"
                    />
                ) : (
                    <IressText data-testid={'no-existing-scenarios'}>{noExistingScenarioLabel}</IressText>
                )}
            </div>
            <div ref={slideoutRef}>
                <IressSlideout
                    id="view-report-slideout"
                    data-testid="view-report-slideout"
                    container={slideoutRef}
                    className={`scenarios-slideout ${show ? 'shown' : ''}`}
                    onExited={() => setShow(false)}
                    onEntered={() => setShow(true)}
                >
                    <IressText element="h3">{selectedScenario?.scenarioName ?? ''}</IressText>
                    <hr />
                </IressSlideout>
            </div>
        </>
    );
};
